export default "__VITE_ASSET__CsBuYKdi__"